import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);

const FALLBACK = {
  business_name: "Tow Truck & Roadside Assistance",
  phone: "",
  email: "",
  is_24_7: false,
  city: "Houston",
  state: "TX",
  service_area_text: "Houston, Texas",
  service_zips: [],
  enabled_services: [],
  tow_services: ["flatbed", "local_tow", "long_distance", "accident", "motorcycle", "transport"],
  maps_enabled: false,
  show_prices: false,
  hours_text: "",
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const load = () =>
    api.get("/public/settings").then((r) => setSettings(r.data)).catch(() => setSettings({ ...FALLBACK, _offline: true }));

  useEffect(() => {
    load();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings: settings || FALLBACK, loaded: !!settings, reload: load }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
